export default __webpack_public_path__ + "static/media/Tenor.43b6603d.png";